var ko = require('knockout');
var stringTemplateEngine = require('knockout-template-loader/lib/string-template-engine');
var htmlContent = "<div id=\"session-expiry-dialog-content\">\r\n    <p>The session has expired, please re-enter your password.</p>\r\n    <div>\r\n        <input type=\"password\"\r\n               data-bind=\"mdlInput: { label: 'Password', id:'password' }, textInput: password\"\r\n               maxlength=\"255\"\r\n               data-automation-id=\"password\" />\r\n    </div>\r\n</div>\r\n";
ko.templates['session-expiry-dialog-content-html'] = htmlContent;


//////////////////
// WEBPACK FOOTER
// ./Scripts/Templates/session-expiry-dialog-content.html
// module id = 116
// module chunks = 4